import { render, staticRenderFns } from "./ParcelWinEdit.vue?vue&type=template&id=618aa51a&"
import script from "./ParcelWinEdit.vue?vue&type=script&lang=js&"
export * from "./ParcelWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./ParcelWinEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618aa51a')) {
      api.createRecord('618aa51a', component.options)
    } else {
      api.reload('618aa51a', component.options)
    }
    module.hot.accept("./ParcelWinEdit.vue?vue&type=template&id=618aa51a&", function () {
      api.rerender('618aa51a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ParcelWinEdit.vue"
export default component.exports